<template>
  <v-container class="py-5">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card outlined>
          <!-- Titre principal -->
          <v-card-title>
            <h1 class="text-h5">Création d'une Étude Alimentaire</h1>
          </v-card-title>

          <!-- Formulaire -->
          <v-form @submit.prevent="submitForm" ref="form">
            <v-card-text>
              <!-- Titre -->
              <v-text-field v-model="form.title" label="Titre" outlined dense required></v-text-field>

              <!-- Date de début -->
              <v-menu
                v-model="startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.start"
                    label="Date de début"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="form.start" @input="startMenu = false" locale="fr"></v-date-picker>
              </v-menu>

              <!-- Date de fin -->
              <v-menu
                v-model="endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.end"
                    label="Date de fin"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="form.end" @input="endMenu = false" locale="fr"></v-date-picker>
              </v-menu>

              <!-- Étude -->

              <v-select
                v-model="selectedConcerns"
                :items="concerns"
                item-value="id"
                item-text="title"
                label="Problématiques"
                outlined
                dense
                required
              ></v-select>
              <v-select
                v-model="form.study"
                :items="studies"
                item-value="id"
                item-text="title"
                label="Étude"
                outlined
                dense
                required
              ></v-select>

              <!-- Cantine -->
              <v-select
                v-model="form.canteen"
                :items="canteens"
                item-value="id"
                item-text="name"
                label="Cantine"
                outlined
                dense
                required
              ></v-select>
            </v-card-text>

            <!-- Boutons -->
            <v-card-actions class="justify-end">
              <v-btn text color="primary" @click="clearForm">Annuler</v-btn>
              <v-btn color="primary" type="submit" elevation="2">Créer</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: "",
        start: "",
        end: "",
        study: null,
        canteen: null,
      },
      studies: [],
      canteens: [],
      selectedConcerns: null,
      concerns: [],
      startMenu: false,
      endMenu: false,
    }
  },
  methods: {
    onIssueChange() {
      console.log("selected", this.selectedConcerns)
      // const params = this.selectedConcerns
      // console.log("params", params)
      this.$store
        .dispatch("fetchAllStudySurveys", { params: this.selectedConcerns })
        .then((response) => {
          console.log("test", response)
          this.studies = response
          console.log(
            "Found experiences",
            JSON.stringify(response),
            this.studies[0]?.survey?.name,
            this.studies[0]?.title
          )
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },
    fetchCurrentPage() {
      console.log("Fetching current page...")
      this.$store
        .dispatch("fetchAllConcerns")
        .then((response) => {
          this.concerns = response
          console.log("Fetched concerns", this.concerns, response)
          // this.onIssueChange()
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
      this.$store
        .dispatch("fetchCanteenSummary")
        .then((response) => {
          this.canteens = response.results
          console.log("Found canteens", JSON.stringify(response), this.canteens)
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },

    submitForm() {
      console.log("Form data", this.form)

      this.$store
        .dispatch("CreateEatingStudy", { payload: this.form })
        .then(() => {
          console.log("Study created successfully")
          this.$router.push("/study-eating/?page=1")
        })
        .catch((error) => {
          console.error("Error during study creation:", error)
          this.$store.dispatch("notifyServerError")
        })
    },

    clearForm() {
      this.form = {
        title: "",
        start: "",
        end: "",
        study: null,
        canteen: null,
      }
      this.startMenu = false
      this.endMenu = false
    },
  },

  watch: {
    $route() {
      this.fetchCurrentPage()
    },
    selectedConcerns(newValue) {
      this.onIssueChange(newValue)
    },
  },
  mounted() {
    // this.fetchConcerns()
    this.fetchCurrentPage()
  },
}
</script>

<style scoped>
.v-container {
  max-width: 600px;
  margin: auto;
}

.v-card-title {
  justify-content: center;
  font-weight: bold;
}

.v-card-actions {
  padding: 16px;
}
</style>
